import { defineComponent as _defineComponent } from 'vue'
import FrontRegularModal from "@/views/pages/global/modals/FrontRegularModal.vue";
import Cookies  from "js-cookie";
import {ref, onMounted, computed} from "vue";
import moment from "moment";

import axiosHelper from "webapp-react/src/shared/axios.helper";

type User = {
  username: string
  email: string
  mobile?: string
  contacts: {
    telegram?: string
    whatsapp?: string
    skype?: string
    phone?: string
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewIntercashCardsUsaFeesModal',
  props: {
  enabled: {
    type: Boolean,
    default: false
  },

},
  setup(__props) {

const props = __props;

const COOKIE_NAME = 'NewIntercashUsaFeesAlert';


const localStorageSupported = ref(true);
const warningModal = ref(null)

const showMessage = () => {
  if (warningModal.value)
    (warningModal.value as FrontRegularModal).showModal();
}

const hideMessage = () => {
  if (warningModal.value)
    (warningModal.value as FrontRegularModal).hideModal();
}


const clickCancel = () => {
  rememberCancelForAwhile();
  hideMessage();
}
const clickOk = () => {
  rememberCancelForAwhile();
  hideMessage();
  // window.location.href = '/cards/issue';
}

const checkLocalStorageSupportedCached = ref(null);

const checkLocalStorageSupported = () => {
  if (checkLocalStorageSupportedCached.value !== null)
    return checkLocalStorageSupportedCached.value;
  try {
    localStorage.setItem(`${COOKIE_NAME}_test`, COOKIE_NAME);
    localStorage.removeItem(`${COOKIE_NAME}_test`);
    return checkLocalStorageSupportedCached.value = true;
  } catch (e) {
    return checkLocalStorageSupportedCached.value = false;
  }
}

const randomSleep = (min: number = 0, max: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, Math.random() * (max - min) + min);
  })
}

const whoami = async (): Promise<User | null> => {
  try {
    await randomSleep(500, 1500);
    const {data: {user}}: {
      data: { user: User }
    } = await axiosHelper.get('/webapi/profile/whoami?m[mode]=requisites');
    // console.log('whoami user', user);
    return user;
  } catch (e) {
    return null;
  }
}

onMounted(async () => {
  if (checkCancel())
    return;
  showMessage();
})

const uidValue = ref('');
const cookieName = computed(() => {
  return COOKIE_NAME + uidValue.value;
})

const onClosed = () => {
  rememberCancelForAwhile();
}

const rememberCancelForAwhile = () => {
  const ttl = moment().add(2, 'weeks');
  const ttlValue: string = ttl.valueOf() + '';
  if (localStorageSupported.value)
    localStorage.setItem(cookieName.value, ttlValue);
  Cookies.set(cookieName.value, ttlValue, {
    expires: ttl.toDate()
  });
}

const checkCancel = () => {
  let t: number;
  if (localStorageSupported.value) {
    t = +localStorage.getItem(cookieName.value) || 0;
  }
  if (!t) {
    t = +Cookies.get(cookieName.value) || 0;
  }
  // console.log('checkCancel', t, moment().valueOf());
  if (t && t > 0) {
    const r = t < moment().valueOf();
    if (r) {
      localStorage.removeItem(cookieName.value);
      Cookies.remove(cookieName.value);
    }
    return !r;
  } else
    return false;
}

// const rememberClose = () => {
//   if (localStorageSupported.value) {
//     localStorage.setItem(COOKIE_NAME, '1');
//   }
//   Cookies.set(COOKIE_NAME, '1');
// }


return { __sfc: true,COOKIE_NAME, props, localStorageSupported, warningModal, showMessage, hideMessage, clickCancel, clickOk, checkLocalStorageSupportedCached, checkLocalStorageSupported, randomSleep, whoami, uidValue, cookieName, onClosed, rememberCancelForAwhile, checkCancel, FrontRegularModal }
}

})